export var FILEUPLOADBUTTON_CLASS_PREFIX = 'FileUploadButton';